import { VENDORS_PORTAL_API_URL } from 'src/constants/urls';

const redirectToMigratedHome = () => {
  window.location.replace(VENDORS_PORTAL_API_URL);
  return null;
};

export const HomeRoutes = [
  {
    path: '/',
    exact: true,
    isPrivate: false,
    component: redirectToMigratedHome,
  },
  {
    path: '/home',
    exact: true,
    redirect: '/',
  },
];
